function titleize (sentence) {
  sentence = sentence || ''
  if (!sentence.split) {
    return sentence
  }
  const _titleizeWord = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  }
  const result = []

  sentence.replace(/_/g, ' ').split(' ').forEach(function (w) {
    result.push(_titleizeWord(w))
  })
  return result.join(' ')
}

export default { titleize }
